module.exports = __webpack_public_path__ + "fonts/Kinetika-BlackItalic.a4ab1d9d.woff2";